import React from 'react'

const Color = ({row}) => {
  return (
    <div>{row?.color?.colorName}</div>
  )
}

export default Color